import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useModalStore } from '@/app/store/modal.store';
import { Button } from '@/components/ui/Button';

export function ModalHost() {
  const modal = useModalStore((s) => s.modal);
  const close = useModalStore((s) => s.close);
  const { t } = useTranslation('common');

  useEffect(() => {
    if (!modal) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        if (modal.onCancel) modal.onCancel();
        else close();
      }
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [modal, close]);

  if (!modal) return null;

  return (
    <div
      className="modal-overlay modal-overlay--visible"
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-host-title"
      onClick={modal.onCancel ?? close}
    >
      <div
        className={`modal${modal.className ? ` ${modal.className}` : ''}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal__header">
          <h3 id="modal-host-title" className="modal__title">{modal.title}</h3>
        </div>
        <div className="modal__body">
          {typeof modal.body === 'string' ? (
            <p className="modal__message">{modal.body}</p>
          ) : (
            modal.body
          )}
        </div>
        <div className="modal__footer">
          {modal.showCancel ? (
            <Button variant="secondary" onClick={modal.onCancel ?? close}>
              {modal.cancelLabel ?? t('actions.cancel')}
            </Button>
          ) : null}
          {modal.confirmDanger ? (
            <button
              type="button"
              className="btn btn--danger"
              onClick={modal.onConfirm ?? close}
            >
              {modal.confirmLabel ?? t('actions.confirm')}
            </button>
          ) : (
            <Button variant="primary" onClick={modal.onConfirm ?? close}>
              {modal.confirmLabel ?? t('actions.confirm')}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
